<template>
  <div>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        style="background-image:url('/img/galleries/large/nature/P3123445.jpg'); background-position: 0% 45%"
      ></parallax>
      <div class="container">
        <h1 class="title">Buy</h1>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <h3 class="title">To put on your wall:</h3>
        <div class="link-container">
          <img class="print-preview" src="/img/camel-couch.jpg">
          <a
            class="about-text"
            href="https://www.ohmyprints.com/de/kuenstler-bilder/Mathias-Möller/54783"
            target="_blank"
            title="Order prints on Oh My Prints"
          >
            Order prints on <br> Oh My Prints
          </a>
        </div>
      </div>
      <div class="container">
        <h3 class="title">To put on your website / presentation / brochure:</h3>
        <stock/>
      </div>
      <div class="container print-container">
        <h3 class="title">For everything else:</h3>
        <div class="link-container">
          <a
            title="Send me a mail"
            href="mailto:mail@mathiasmoeller.com"
            target="_blank"
          >
            Drop me a message for custom enquiries
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Stock } from '@/components';
  import { metaTitles, metaDescriptions, metaImage } from '@/utils/meta';

  export default {
    name: 'buy',
    bodyClass: 'profile-page',
    metaInfo: {
      title: 'Buy',
      meta: [
        ...metaTitles('Buy'),
        ...metaDescriptions('Buy my images'),
        ...metaImage('/img/galleries/thumbs/nature/P3123445-small.jpg', 640, 213),
      ],
    },
    components: {
      Stock,
    },
  };
</script>
<style lang="scss" scoped>
  @import "../assets/scss/now-ui-kit/_variables";

  .section {
    padding-top: 20px;
  }

  a {
    font-size: 1.4em;
    margin: auto 20px;
    text-align: center;
  }

  .link-container {
    display: flex;
    justify-content: center;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;

      a {
        margin: 20px 20px auto 20px;
      }

      .print-preview {
        max-width: 80%;
      }
    }
  }

  .print-container {
    margin-top: 30px;
    margin-bottom: 15px;
  }

  .print-preview {
    max-height: 400px;
    max-width: 50%;
  }
</style>
